/**
 * Promise to read a blob as Data URL
 *
 * If the input is a string, it will be returned untouched
 *
 * @param {Blob|string} input - a Blob or a string
 * @returns
 */
const readAsDataURL = (input: Blob | string) =>
  new Promise<string>((resolve, reject) => {
    if (input instanceof Blob) {
      const reader = new FileReader();

      reader.onload = () => {
        // readAsDataURL ensures a string is returned
        resolve(reader.result as string);
      };

      reader.onerror = reject;

      reader.readAsDataURL(input);

      return;
    }

    resolve(input);
  });

export default readAsDataURL;
